import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.css';
const VnGrid = ({ children, header }) => {
    return (_jsxs(_Fragment, { children: [_jsx("div", { children: header }), _jsx("div", { className: 'vn-table-main', children: _jsx("div", { children: children }) })] }));
};
export default VnGrid;
